<div class="crumbs">
  <span class="crumb-strong">{{ currentTypeLabel | titlecase }}</span>
  <i class="fa fa-angle-right"></i>
  <span>{{ currentTitle }}</span>
</div>

<span class="version-pill">v{{ version || 1 }}</span>

<div class="toolbar-spacer"></div>

<div class="toolbar-right">
  <div class="inline-search">
    <i class="fa fa-search"></i>
    <input type="text" placeholder="Search elements..." [ngModel]="searchTerm" (ngModelChange)="searchChange.emit($event)">
  </div>

  <button class="toolbar-btn" type="button" (click)="undoClick.emit()" [disabled]="!canUndo">
    <i class="fa fa-undo"></i>
    <span>Undo</span>
  </button>

  <button class="toolbar-btn" type="button" (click)="redoClick.emit()" [disabled]="!canRedo">
    <i class="fa fa-repeat"></i>
    <span>Redo</span>
  </button>

  <div class="toolbar-dropdown">
    <button class="toolbar-btn primary save-toolbar-trigger" type="button" command="show-popover"
      commandfor="save-toolbar-popover">
      <i class="fa"
        [ngClass]="{'fa-save': mainSaveState === 'idle', 'fa-spinner fa-spin': mainSaveState === 'saving', 'fa-check': mainSaveState === 'success'}"></i>
      <span>Save</span>
      <i class="fa fa-caret-down caret"></i>
    </button>
    <div id="save-toolbar-popover" class="toolbar-dropdown-menu toolbar-popover" popover="auto">
      <button class="dropdown-item" commandfor="save-toolbar-popover" command="hide-popover"
        (click)="saveClick.emit()" [disabled]="mainSaveState === 'saving' || isDualPane || isViewingDiff || !hasName">
        <i class="fa"
          [ngClass]="{'fa-save': mainSaveState === 'idle', 'fa-spinner fa-spin': mainSaveState === 'saving', 'fa-check': mainSaveState === 'success'}"></i>
        Save
      </button>
      <button class="dropdown-item" commandfor="save-toolbar-popover" command="hide-popover"
        (click)="openSaveAsClick.emit()" [disabled]="saveAsState === 'saving' || isViewingDiff">
        <i class="fa"
          [ngClass]="{'fa-save': saveAsState === 'idle', 'fa-spinner fa-spin': saveAsState === 'saving', 'fa-check': saveAsState === 'success'}"></i>
        Save as...
      </button>

    </div>
  </div>

  <button class="toolbar-btn" type="button" (click)="toggleVersionsClick.emit()"
    [class.active]="showVersionsModal || isViewingDiff">
    <i class="fa fa-history"></i>
    <span>{{ isViewingDiff ? 'Exit diff' : 'Versions' }}</span>
  </button>

  <button class="toolbar-btn" type="button" (click)="livePreviewClick.emit()">
    <i class="fa fa-external-link"></i>
    <span>Live Preview</span>
  </button>

  <button class="toolbar-btn" type="button" (click)="toggleDualPaneClick.emit()"
    [disabled]="isViewingDiff" [class.active]="isDualPane">
    <i class="fa fa-columns"></i>
    <span>Dual Pane</span>
  </button>



  @if (showNewTrainingPane) {
  <div class="toolbar-chip-group">
    <button class="toolbar-btn" type="button" (click)="copySourceClick.emit()">
      <i class="fa fa-clone"></i>
      <span>Copy Source</span>
    </button>
    <button class="toolbar-btn primary" type="button" (click)="saveNewTrainingClick.emit()"
      [disabled]="saveState === 'saving'">
      <i class="fa"
        [ngClass]="{'fa-save': saveState === 'idle', 'fa-spinner fa-spin': saveState === 'saving', 'fa-check': saveState === 'success'}"></i>
      <span>Save</span>
    </button>
    <button class="toolbar-btn" type="button" (click)="closeNewTrainingClick.emit()">
      <i class="fa fa-times"></i>
    </button>
  </div>
  }
</div>
